import { CrudBase } from "../../crud";
import { BasicCrud } from "../../../utils/interfaces/crud/imp/crud-basic";
import { QuestionnaireModel, QuestionnaireCreateModel } from "../../../models/questionnaire";

class _QuestionnaireController extends CrudBase {
    createModel = QuestionnaireCreateModel;

    constructor() {
        super({
            name: "questionnaire",
            modules: {
                crud: new BasicCrud()
            },
            model: QuestionnaireModel
        });
    }

    onReady() {
        this.actions = this.repo.questionnaire;
        this.routes.edit = "/Questionnaire/Maintenance/"
    }

    goToSection(section) {
        this.app.$router.push(`${this.routes.edit}${this.formData.id}/Section/${section.id}`);
    }

    async onAdd() {
        this.formData = new this.defaultModel({ title: "New Questionnaire" });

        var response = await this.create();
        this.list.push(response.data);
        this.app.$router.push(`${this.routes.edit}${response.data.id}`)
    }

    async create() {
        return await this.execute(this.actions.create, this.formData);
    }

    async addSection() {
        var section_ctrl = this.app.get_controller("questionnaire_section");

        var response = await section_ctrl.create(this.formData.id)

        this.formData.questionnaireSections.push(response.data);

        this.app.$refs.confirmationDialog.showDialog({
            title: `Section Created!`,
            message: `Would you like to edit this section now?`,
            callback: "goToSection",
            callbackData: response.data,
            controller: "questionnaire"
        });
    }
}

export const QuestionnaireController = new _QuestionnaireController();